import {FormBuilder, FormGroup} from "@angular/forms";
import {Component, Injector, Input} from "@angular/core";
import {DraftModel} from "../../models/draft.model";
import {DraftsService} from "../../services/drafts.service";
import {ModifyDraftModel} from "../../models/modify-draft.model";
import {BasePageModal} from "../../../base/components/base-page-modal";

@Component({
  selector: 'app-edit-draft-modal',
  templateUrl: './edit-draft-modal.component.html',
  styleUrls: ['./edit-draft-modal.component.scss']
})
export class EditDraftModalComponent extends BasePageModal {

  @Input() draft: DraftModel;

  editDraftForm: FormGroup;

  constructor(injector: Injector, private fb: FormBuilder, private draftsService: DraftsService) {
    super(injector);
  }

  pageName(): string {
    return 'EditDraftModalComponent';
  }

  ngOnInitForChildren(): void {
  }

  ngOnDestroyForChildren(): void {
  }

  onEditedForm(event) {
    if (event.name === 'formEdited') {
      this.editDraftForm = event.payload;
    }
  }

  private buildDraft(): ModifyDraftModel {
    let originalDraft: DraftModel = this.clonerService.deepClone(this.draft);

    let draftToEdit: ModifyDraftModel = new ModifyDraftModel();
    draftToEdit.changeOperator = this.editDraftForm.get('changeOperator').value;
    draftToEdit.expirationDate = originalDraft.expirationDate;
    draftToEdit.reserved = this.editDraftForm.get('isPrivate').value;
    draftToEdit.name = this.editDraftForm.get('draft').value;
    draftToEdit.state = this.draft.state;
    return draftToEdit;
  }

  onSaveDraft() {
    this.editDraftForm.markAsPending();
    this.draftsService.editDraft(this.draft.processId, this.buildDraft()).subscribe(() => {
      this.editDraftForm.reset();
      this.closeModal('edit-draft-modal');
      this.notifyActionSimple('onEdit');
    }, (error => {
      this.editDraftForm.updateValueAndValidity();
      console.log(this.editDraftForm);
    }));
  }
}
